export class OrderFakeItemModel {
	productIdOnSeller: string = ''
	quantity: number = 1
	unitPrice: number = 1
	discount: number = 0
	increment: number = 0
	isGift: boolean = false

	isValid():boolean {
		return !!this.productIdOnSeller &&
			!!this.quantity &&
			!!this.unitPrice
	}
}
